var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var calculateResolutionSize = function (value, resolution) {
    return typeof value === "number" ? value * resolution : value;
};
export var generateImageProcessorParamsWithWidthAndHeight = function (breakpointIndex, resolution, width, height, focalPoint, imageProcessorParams) { return (__assign(__assign(__assign(__assign(__assign({}, (width && Array.isArray(width) && width[breakpointIndex]
    ? {
        width: calculateResolutionSize(width[breakpointIndex], resolution),
    }
    : width &&
        !Array.isArray(width) && {
        width: calculateResolutionSize(width, resolution),
    })), (height && Array.isArray(height) && height[breakpointIndex]
    ? {
        height: calculateResolutionSize(height[breakpointIndex], resolution),
    }
    : height &&
        !Array.isArray(height) && {
        height: calculateResolutionSize(height, resolution),
    })), (imageProcessorParams &&
    Array.isArray(imageProcessorParams) &&
    imageProcessorParams[breakpointIndex]
    ? __assign({}, imageProcessorParams[breakpointIndex]) : imageProcessorParams &&
    !Array.isArray(imageProcessorParams) && __assign({}, imageProcessorParams))), (focalPoint && {
    rxy: focalPoint.left + "," + focalPoint.top,
})), { mode: "crop" })); };
